import { ICellRendererParams } from "@ag-grid-community/core";
import { Component, OnDestroy } from "@angular/core";
import { Pricing } from "src/app/models/priceyard.model";
import { CurrencyPipe } from "@angular/common";
import { MatDialog } from "@angular/material/dialog";
import { PriceRangePopupComponent } from "src/app/modules/priceyard/price-range-popup/price-range-popup.component";
import { Subject } from "rxjs";

@Component({
  selector: "app-multi-price-cell-renderer",
  templateUrl: "./multi-price-cell-renderer.component.html",
  styleUrls: ["./multi-price-cell-renderer.component.scss"],
})
export class MultiPriceCellRendererComponent implements OnDestroy {
  pricing: Pricing[];
  displayArrow: boolean = false;
  private destroy$ = new Subject<void>();
  params: ICellRendererParams;
  constructor(private currencyPipe: CurrencyPipe,
    private dialog: MatDialog) {}
  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.pricing = params["props"].map((e) => {
      return {
        name: e.label,
        price: this.convertPrice(params.data[e.priceProp], e.label),
        isManual: e.autoProp ? params.data[e.autoProp] : undefined,
        markUpType: e.type ? params.data[e.type] : undefined,
        isMappedPriceAuto: e.isAuto ? params.data[e.isAuto] : undefined,
      };
    });
    const index = this.pricing.findIndex(
      (res) => res.name === "Default" && res.price === null
    );
    if (index > -1) {
      this.pricing.splice(index, 1);
    }
    this.displayArrow = this.pricing.findIndex((res) => res.name === "Breakeven") !== -1;
  }

  convertPrice(price, label) {
    if (!price) {
      if (label === "Min" || label === "Max" || label === "Breakeven") {
        return "Not set";
      } else {
        return null;
      }
    } else {
      return this.currencyPipe.transform(price, "USD", "symbol", "1.0-2");
    }
  }

  openExpandDialog(event: MouseEvent) {
    event.stopPropagation();
    this.dialog.open(PriceRangePopupComponent, {
      position: this.getDialogPosition(event),
      width: '663px',
      data: {
        params: this.params,
        isFlexedCol : true
      },
      backdropClass: ["cdk-overlay-transparent-backdrop", "arrow-backdrop"],
    })
  }

  getDialogPosition(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    return {
      bottom: targetPosision.bottom < 612 ? targetPosision.bottom + "px" : "612px",
      left: targetPosision.left <= 1269 ? (targetPosision.left + "px") : '1269px' ,
      right: targetPosision.right + "px",
      top: targetPosision.top > 500 ? "400px" : targetPosision.top + "px",
    }; 
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
